// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationKIN from './locales/rw/translation.json';
import translationFR from './locales/fr/translation.json';

// Define the resources
const resources = {
  en: {
    translation: translationEN
  },
  kiny: {
    translation: translationKIN
  },
  fr: {
    translation: translationFR
  }
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'kiny', 'fr'],
    debug: true, // Enable debug temporarily to help diagnose issues
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true
    }
  });

export default i18n;
